module.exports = __webpack_public_path__ + "static/media/pip_bird.5fff92a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pip_bird.png
// module id = 306
// module chunks = 0